module.exports = __webpack_public_path__ + "static/media/2.cb4ca8a4.jpg";